import React from "react";
import "./Loader.css";
import govLogo from "../../assets/emblem-dark.png"; // Use your actual logo path

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="logo-pulse-color">
        <img src={govLogo} alt="Government Logo" />
      </div>
    </div>
  );
};

export default Loader;
